/**
 * Format selector inside a collection-product-gallery product window.
 * All prices are server-rendered (one span per linked variant, keyed by
 * data-variant-price); this element only toggles their visibility to match
 * the checked size radio. Add-ons not linked to the selected format show
 * their "—" span and the tile grays out.
 */
class GalleryFormatSelector extends HTMLElement {
  connectedCallback() {
    // Named handler + removal on disconnect: an anonymous listener was never
    // removed, so a section reload (disconnect → reconnect of the same instance)
    // stacked duplicate handlers and re-ran the filtering once per accumulated
    // listener.
    this.onChange = (event) => {
      const radio = event.target.closest('.collection-product-gallery__row-radio');
      if (radio) this.#apply(radio.value);
    };
    this.addEventListener('change', this.onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
  }

  #apply(variantId) {
    for (const tile of this.querySelectorAll('.collection-product-gallery__option-tile')) {
      let matched = false;

      for (const price of tile.querySelectorAll('[data-variant-price]')) {
        const hit = price.dataset.variantPrice === variantId;
        price.hidden = !hit;
        if (hit) matched = true;
      }

      const na = tile.querySelector('[data-addon-na]');
      if (na) na.hidden = matched;
      tile.classList.toggle('collection-product-gallery__option-tile--unavailable', !matched);
    }
  }
}

customElements.define('gallery-format-selector', GalleryFormatSelector);
